import React from "react";
import { Lock, Clock } from "lucide-react";
import { STATE_LABELS, STATE_TOOLTIPS, enhancedTriggerLabel } from "../../lib/ecosystemApi";

/** Distinct colours per lifecycle state.  INACTIVE / EXPIRED /
 *  ARCHIVED / RETIRED never share visual weight. */
const STATE_STYLE = {
  DRAFT: "bg-slate-100 text-slate-800 border-slate-300",
  REVIEW: "bg-sky-50 text-sky-900 border-sky-300",
  REJECTED: "bg-yellow-50 text-yellow-900 border-yellow-400",
  APPROVED: "bg-blue-50 text-blue-900 border-blue-400",
  PATIENT_VISIBLE: "bg-emerald-50 text-emerald-900 border-emerald-500 font-semibold",
  INACTIVE: "bg-slate-50 text-slate-500 border-slate-200",
  EXPIRED: "bg-orange-50 text-orange-700 border-orange-200",
  ARCHIVED: "bg-zinc-100 text-zinc-600 border-zinc-300",
  RETIRED: "bg-neutral-800 text-neutral-100 border-neutral-900",
};

export function LifecycleChip({ state }) {
  const label = STATE_LABELS[state] || state;
  const tip = STATE_TOOLTIPS[state] || "";
  const cls = STATE_STYLE[state] || "bg-slate-100 text-slate-800 border-slate-300";
  return (
    <span
      data-testid={`lifecycle-chip-${state}`}
      title={tip}
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full border ${cls}`}
    >
      {state === "RETIRED" && <Lock size={12} data-testid="retired-lock-icon" />}
      {state === "EXPIRED" && <Clock size={12} data-testid="expired-clock-icon" />}
      {label}
    </span>
  );
}

/** Enhanced Review — amber, distinct from danger red. */
export function EnhancedChip({ classification }) {
  const label = enhancedTriggerLabel(classification);
  if (!label) return null;
  return (
    <span
      data-testid="enhanced-chip"
      title="Enhanced review classification — requires enhanced_reviewer approval"
      className="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full border border-amber-500 bg-amber-50 text-amber-900 font-medium"
    >
      {label}
    </span>
  );
}

export function VersionDot({ kind }) {
  const map = {
    "patient-visible": { cls: "bg-emerald-500", label: "Patient-visible" },
    "approved": { cls: "bg-blue-500", label: "Approved" },
    "historical": { cls: "bg-slate-300", label: "Historical" },
    "rejected": { cls: "bg-yellow-500", label: "Rejected" },
  };
  const { cls, label } = map[kind] || map.historical;
  return (
    <span
      data-testid={`version-dot-${kind}`}
      title={label}
      className={`inline-block w-2.5 h-2.5 rounded-full ${cls}`}
    />
  );
}
